<input
        [dwsPermission]="permission"
        dwsPermissionDenyMode="disable"
        (blur)="onBlurInternal($event)"
        (focus)="onFocusInternal($event)"
        (input)="onInputChange($event)"
        [attr.inputmode]="inputMode"
        [attr.name]="name"
        [attr.placeholder]="placeholder"
        [attr.type]="type"
        [disabled]="disabled"
        [pattern]="pattern"
        [readonly]="readonly"
        [required]="required"
        [value]="value"
        [class.ng-touched]="touched"
        [class.ng-invalid]="invalid"
        matInput
>